import api from './index';

interface GetNextNotificationForTheCurrentUserProps {}
const getNextNotificationForTheCurrentUser = (
  props?: GetNextNotificationForTheCurrentUserProps,
) => {
  return api.get(`/v4/notification`, props);
};

const putNotificationRead = (notificationId: string) => {
  return api.put(`/v4/notification/${notificationId}/read`);
};

export const NotificationService = {
  getNextNotificationForTheCurrentUser,
  putNotificationRead,
};
